module.exports = __webpack_public_path__ + "static/media/path5.ceb241f0.png";